import { StructureList } from '../../models/structure-list';
import { SettingsService } from '../../settings/settings.service';
import { DocumentService } from '../../services/document.service';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { LdwRouterService } from '../../../route/ldw-router.service';
import { SelectionArguments } from '../../models/selection-arguments';
import { StructureType } from '../../enums/structure-type';
import { SelectionType } from '../../enums/selection-type';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { InfoService } from '../../services/info.service';

export class DetailPageBase {
  protected wdSubscription!: Subscription;
  public documents: StructureList = new StructureList();
  public hasDetail = false;
  public detailDocumentId = '';
  protected lastNodeId = '';
  lastSelectedId = '';
  protected updateRouteOnSelection = false;
  protected firstLoad = true;
  public showNoData = false;
  public allowSplitMode = true;
  constructor(
    protected settingsService: SettingsService,
    protected documentService: DocumentService,
    protected webdokuService: WebdokuService,
    protected routerService: LdwRouterService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected infoService: InfoService,
    clear = true
  ) {
    if (clear) {
      this.infoService.clearStatus();
    }
    this.wdSubscription = webdokuService.webDokuChange.subscribe(() => {
      this.webDokuChanged();
    });
  }

  protected ClearStatusIfNotFirstLoad(): void {
    if (!this.firstLoad) {
      this.infoService.clearStatus();
    }
    this.firstLoad = true;
  }

  protected getLastStateFromRoute() {
    this.lastNodeId = this.route.snapshot.paramMap.get('nodeId') ?? '';
    this.lastSelectedId = this.route.snapshot.paramMap.get('selectedId') ?? '';
  }

  protected updateRoute(nodeId: string, selectedId: string) {
    if (nodeId == null || nodeId.length == 0) {
      console.log('update route null');
      return;
    }

    if (selectedId == null || selectedId.length == 0) {
      console.log('update route ' + nodeId);
      this.router.navigate([{ nodeId: nodeId }], { relativeTo: this.route });
      return;
    }
    console.log('update route ' + nodeId + ' --- ' + selectedId);
    this.router.navigate([{ nodeId: nodeId, selectedId: selectedId }], {
      relativeTo: this.route,
    });
  }

  private webDokuChanged() {
    this.documents = new StructureList();
  }

  public get useSplitMode(): boolean {
    return this.allowSplitMode && this.settingsService.settings.documentMode.useListPreview;
  }

  public closeDetail() {
    this.hasDetail = false;
    this.detailDocumentId = '';
  }

  activateInternalEditorView(docId: string) {
    this.hasDetail = true;
    this.detailDocumentId = docId;
  }

  detailVisibleChanged(value: boolean) {
    this.hasDetail = value;
  }

  selectItem(args: SelectionArguments) {
    if (args == undefined || args.id == undefined) {
      return;
    }
    if (args.structureType != StructureType.Document) {
      return;
    }

    if (args.action == SelectionType.Preview) {
      this.activateInternalEditorView(args.id);
      return;
    }

    let selType = args.action;
    if (args.action == SelectionType.Selected) {
      selType = SelectionType.View;
    }

    if (this.updateRouteOnSelection) {
      console.log('update from selection');
      console.log('last node: ' + this.lastNodeId);
      console.log('selection: ' + args.id);
      this.updateRoute(this.lastNodeId, args.id);
    }

    this.routerService.navigateToDocumentBySelectionType(selType, args.id);
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
